import { useEffect } from 'react'
import { isMac } from 'shared/lib/deviceDetector'

type IModifier = 'ctrl' | 'shift' | 'alt'

type IUseHotkeyOptions = {
  key: string
  modifiers?: IModifier[]
  handler: () => void
  enabled?: boolean
}

const ALL_MODIFIERS: IModifier[] = ['ctrl', 'shift', 'alt']

const modifierChecks: Record<IModifier, (event: KeyboardEvent) => boolean> = {
  ctrl: (event) => (isMac ? event.metaKey : event.ctrlKey),
  shift: (event) => event.shiftKey,
  alt: (event) => event.altKey,
}

export const useHotkey = ({ key, modifiers = [], handler, enabled = true }: IUseHotkeyOptions) => {
  const modifiersKey = modifiers.join('+')

  useEffect(() => {
    if (!enabled) return

    const handleKeyDown = (event: KeyboardEvent) => {
      const allModifiersMatch = ALL_MODIFIERS.every(
        (modifier) => modifierChecks[modifier](event) === modifiers.includes(modifier)
      )

      if (!allModifiersMatch) return
      if (event.code !== key) return

      event.preventDefault()
      handler()
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [key, modifiersKey, handler, enabled])
}
